import React, { Component } from "react";

import NavbarHome from "../components/NavbarHome/NavbarHome";
import Header from "../components/Header/Header";
import About from "../components/About/About";
import Goals from "../components/Goals/Goals";
import Programs from "../components/Programs/Programs";
import Accomplishments from "../components/Accomplishments/Accomplishments";
import LearningPath from "../components/LearningPath/LearningPath";
import News from "../components/News/News";
import ContactUs from "../components/ContactUs/ContactUs";
import Location from "../components/Location/Location";
import BackToTop from "../components/BackToTop/BackToTop";

class Home extends Component {
  state = {
    isNavOpen: false
  };

  onNavOpen = () => {
    this.setState({ isNavOpen: !this.state.isNavOpen });
  };

  render() {
    return (
      <>
        <NavbarHome
          onNavOpen={this.onNavOpen}
          isNavOpen={this.state.isNavOpen}
        />
        <Header isNavOpen={this.state.isNavOpen} onNavOpen={this.onNavOpen} />
        <About />
        <Goals />
        <Programs />
        <Accomplishments />
        <LearningPath />
        <News />
        <ContactUs />
        <Location />
        <BackToTop />
        {/* <Footer /> */}
      </>
    );
  }
}

export default Home;
